import './Footer.css';

const year = new Date().getFullYear();

export function Footer() {
    return (
        <footer id="footer">
            <p>
                © {year} EduNexus. All rights reserved.
            </p>
        </footer>
    );
}

export default Footer;